module.exports = "<div class=\"em-widget-error-prompt hide\"> <span></span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/js/common/uikit/template/tipsTpl.html
// module id = 220
// module chunks = 0